<template>
  <div id='homePage'>
    <Header></Header>
    <Content></Content>
  </div>
</template>

<script>
import Header from '../components/header.vue'
import Content from '../components/content.vue'
export default {
  name: 'HomePage',
  components: {
    Header,
    Content
  }
}
</script>

<style scoped>
@media (min-width:1441px) {
  #homePage {
    zoom: 1;
  }
}
</style>